/*
 * $Id:: appService.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import literals from '../assets/tempDataSources/literals';
import { sendRequest } from '../common/utils';

export function queryGlobals() {
    return sendRequest({
        url: '/content/global',
        method: 'GET',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { code: error.code || 500, description: 'Could not fetch globals' } };
        });
}

export function queryLiterals({ language }) {
    let myStorage = window.sessionStorage;
    let userLang = myStorage.getItem('lang');
    const lang = language || userLang || 'pt';
    return sendRequest({
        url: `/content/literal/${lang}`,
        method: 'GET',
    })
        .then((response) => {
            document.documentElement.lang = lang; // set in html lang attribute
            return {
                ...((literals && literals[lang]) || {}),
                ...response,
            };
        })
        .catch((error) => {
            return { error: { code: error.code || 500, description: 'Could not fetch literals' } };
        });
}

export function queryCountries() {
    return sendRequest({
        url: '/content/country',
        method: 'GET',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { code: error.code || 500, description: 'Could not fetch countries' } };
        });
}
